import DummyRouter from '@/features/ui/components/DummyRouter.vue'

import { fullSuperAdminGuard } from './fullSuperAdminGuard.js'

export const superAdminLimitedUsersRoutes = [
  {
    path: 'users',
    component: DummyRouter,
    beforeEnter: fullSuperAdminGuard,
    children: [
      {
        path: '',
        component: () => import('./SuperAdminLimitedUsersListView.vue'),
      },
      {
        path: 'new',
        component: () => import('./SuperAdminLimitedUserDetailView.vue'),
      },
      {
        path: ':profileId',
        component: () => import('./SuperAdminLimitedUserDetailView.vue'),
      },
    ],
  },
]
